<ng-container *ngIf="authorization; else noAuth">
<app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

<div class="form" style="padding-bottom: 70px">
  <div style="text-align: center; padding-bottom: 20px; padding-top: 20px">
    <h3>Compila il questionario!</h3>
    <h4>Per ogni domanda selezionare un valore da 1 a 4, dove:</h4>
    <div style="font-weight: bold; padding: 20px"
         fxLayout
         fxLayout.xs="column"
         fxLayoutAlign="center"
         fxLayoutGap.xs="0">
      <div class="item item-1" fxFlex="0%">1</div>
      <div class="item item-2" fxFlex="0%" fxFlexOrder="2">2</div>
      <div class="item item-3" fxFlex="0%" fxFlexOrder="3">3</div>
      <div class="item item-4" fxFlex fxFlexOrder="4">4</div>
    </div>
    <div style="font-weight: bold;
       background-color: whitesmoke; padding: 20px"
         fxLayout
         fxLayout.xs="column"
         fxLayoutAlign="center"
         fxLayoutGap.xs="0">
      <div class="item item-1" fxFlex="0%">No</div>
      <div class="item item-2" fxFlex="0%" fxFlexOrder="2">Un po'</div>
      <div class="item item-3" fxFlex="0%" fxFlexOrder="3">Parecchio</div>
      <div class="item item-4" fxFlex fxFlexOrder="4">Moltissimo</div>
    </div>
  </div>

<form (ngSubmit)="onSubmit()">

  <div class="container mat-elevation-z5">

    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.position}} </td>
      </ng-container>


      <ng-container matColumnDef="question">
        <th mat-header-cell *matHeaderCellDef> Domanda </th>
        <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.question}}
          <ng-container *ngIf="questionnaire.position == 29 || questionnaire.position == 30">
            <br><br><strong>Selezionare un valore da 1 a 7, dove:</strong>
            <ul>
              <li>1: Pessima</li>
              <li>7: Ottima</li>
            </ul>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> Valore </th>
        <td mat-cell *matCellDef="let questionnaire">
          <mat-form-field>
            <mat-label>Seleziona un valore</mat-label>
            <mat-select required>
              <ng-container *ngIf="questionnaire.position < 29 || questionnaire.position > 30; else otherValues">
              <mat-option *ngFor="let value of values" [value]="value"
                          (onSelectionChange)="selectResult($event, value, questionnaire.position)">
                {{value}}
              </mat-option>
              </ng-container>
              <ng-template #otherValues>
                <mat-option *ngFor="let value of values2q" [value]="value"
                            (onSelectionChange)="selectResult($event, value, questionnaire.position)">
                  {{value}}
                </mat-option>
              </ng-template>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

  </div>


  <div style="text-align: center; padding-top: 50px">
    <ng-container *ngIf="submitted">
      <div style="justify-content: center; align-content: center; align-items: center; padding-bottom: 50px">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </ng-container>

    <div style="text-align: center">
      <ng-container *ngIf="!show">
        <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary">Invia</button>
      </ng-container>
    </div>
  </div>

</form>
</div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>
